import type {
  CreateInvoiceBlockRequest,
  InvoiceBlockKind,
  InvoiceBlockResponse,
  InvoiceTaxCategory,
} from '@/shared/api';

export interface InvoiceBlockFormState {
  label: string;
  kind: InvoiceBlockKind;
  taxCategory: InvoiceTaxCategory;
  unitPrice: string;
  isActive: boolean;
  notes: string;
}

export function initialBlockForm(block: InvoiceBlockResponse | null): InvoiceBlockFormState {
  return {
    label: block?.label ?? '',
    kind: block?.kind ?? 'PerStay',
    taxCategory: block?.taxCategory ?? 'Services',
    unitPrice: block ? String(block.unitPrice) : '',
    isActive: block?.isActive ?? true,
    notes: block?.notes ?? '',
  };
}

/**
 * Prüft die Eingabe und baut daraus die Anfrage. Die Regeln sind unverändert; sie liegen nur
 * nicht mehr in der Komponente.
 */
export function toBlockRequest(
  form: InvoiceBlockFormState,
): { ok: true; value: CreateInvoiceBlockRequest } | { ok: false; error: string } {
  if (!form.label.trim()) {
    return { ok: false, error: 'Bitte einen Namen vergeben.' };
  }
  const price = Number(form.unitPrice.replace(',', '.'));
  if (!Number.isFinite(price) || price < 0) {
    return { ok: false, error: 'Bitte einen gültigen Preis eingeben.' };
  }
  return {
    ok: true,
    value: {
      label: form.label.trim(),
      kind: form.kind,
      taxCategory: form.taxCategory,
      unitPrice: price,
      currency: null,
      isActive: form.isActive,
      notes: form.notes.trim() || null,
    },
  };
}
